import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {planingAreaRangeCalcFactory, RangeCalc} from './calculations/planing-area-range.calc';
import {LEFT_BORDER_6H_IN_MINUTES} from '../../blocks/planing-area-block/planing-area-block.constants';

@Component({
  selector: 's-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RangeSliderComponent implements OnInit, OnChanges {
  @Input() rangeValues;
  @Input() rangeLimitValues;
  @Input() realWidth = 100;
  @Input() limitType: string;
  @Input() leftLabelValue;
  @Input() rightLabelValue;
  @Input() minValue = 0;
  @Input() maxValue = 1000;
  @Input() disabled = false;
  @Input() limitLabels = ['', ''];
  @Input() maxDeltaInMinutes = LEFT_BORDER_6H_IN_MINUTES;

  @Output() changeLabels = new EventEmitter<any>();
  public leftHandleRangeStyle = {};
  public rightHandleRangeStyle = {};
  public leftLimitStyle = {};
  public rightLimitStyle = {};
  public showLeftLimit = false;
  public showRightLimit = false;
  private calculator: RangeCalc;

  constructor(private cb: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.calculator = planingAreaRangeCalcFactory(
      this.limitType,
      this.rangeLimitValues,
      [this.minValue, this.maxValue]
    );
    this.calcFromLabels();
    this.calcMarginsAndLimits();
  }

  ngOnChanges(data) {

      this.calculator = planingAreaRangeCalcFactory(
        data.limitType ? data.limitType.currentValue : this.limitType,
        this.rangeLimitValues,
        [this.minValue, this.maxValue]);

      this.calcFromLabels();

    this.calcMarginsAndLimits();
    this.triggerChangeLabels();
    setTimeout(() => this.cb.markForCheck(), 0);
  }

  public calcFromLabels() {
    this.rangeValues = [
      this.calculator.calcLeftSliderValue(this.leftLabelValue),
      this.calculator.calcRightSliderValue(this.rightLabelValue)
    ];
    if (this.rangeValues[0] > this.rangeValues[1]) {
      const tmp = this.rangeValues[0];
      this.rangeValues[0] = this.rangeValues[1];
      this.rangeValues[1] = tmp;
    }
  }

  /**
   * Увеличивает указанную метку на единицу
   * @param labelName
   */
  public incLabel(labelName) {
    this[labelName] += 1;
    this.calcFromLabels();
    this.calcMarginsAndLimits();
    this.triggerChangeLabels();
  }

  /**
   * Уменьшает указанную метку на единицу
   * @param labelName
   */
  public decLabel(labelName) {
    this[labelName] -= 1;
    this.calcFromLabels();
    this.calcMarginsAndLimits();
    this.triggerChangeLabels();
  }


  public triggerChangeLabels() {
    this.changeLabels.emit([this.leftLabelValue, this.rightLabelValue]);
  }

  /**
   * Расчитать реальные смещения после обновления данных
   */
  public calcMarginsAndLimits() {
    const _rangeLimitValues = this.calculator.bordersWithHoles() || [];

    this.showLeftLimit = !!_rangeLimitValues[0];
    this.showRightLimit = !!_rangeLimitValues[1];

    if (this.showLeftLimit) {
      this.leftLimitStyle['margin-left'] = (this.rangeLimitValues[0] * (this.realWidth / this.maxValue)) + '%';
    }
    if (this.showRightLimit) {
      this.rightLimitStyle['margin-left'] = (this.rangeLimitValues[1] * (this.realWidth / this.maxValue)) + '%';
    }

    if (this.showLeftLimit) {
      if (this.rangeValues[0] > this.rangeLimitValues[0] + this.maxDeltaInMinutes) {
        this.rangeValues[0] = this.rangeLimitValues[0] + this.maxDeltaInMinutes;
      }
      if (this.rangeValues[1] < this.rangeLimitValues[0] - this.maxDeltaInMinutes) {
        this.rangeValues[1] = this.rangeLimitValues[0] - this.maxDeltaInMinutes;
      }
    }

    if (this.showRightLimit) {
      if (this.rangeValues[1] < (this.rangeLimitValues[1] - this.maxDeltaInMinutes)) {
        this.rangeValues[1] = this.rangeLimitValues[1] - this.maxDeltaInMinutes;
      }
      if (this.rangeValues[0] > this.rangeLimitValues[1] + this.maxDeltaInMinutes) {
        this.rangeValues[0] = this.rangeLimitValues[1] + this.maxDeltaInMinutes;
      }
    }
    this.leftHandleRangeStyle['left'] = (this.rangeValues[0] * (this.realWidth / this.maxValue) - 0.5) + '%';

    this.rightHandleRangeStyle['left'] = (this.rangeValues[1] * (this.realWidth / this.maxValue)) + '%';
    this.rightHandleRangeStyle['margin-top'] = '-2.5em';

    this.leftLabelValue = this.calculator.calcLeftBoundValue(this.rangeValues[0]);
    this.rightLabelValue = this.calculator.calcRightBoundValue(this.rangeValues[1]);
  }
}
